import eventTerms from './data/event-terms-cn'
import eventTermsTradego from './data/event-terms-tradego-cn'
import eventTermsMultiple from './data/event-terms-multiple-cn'
import activityNewUser8 from './data/activity-new-user8-cn'
import activityEssenceReward from './data/activity-essence-reward-cn'
import activityInviteFriend from './data/activity-invite-friend-cn'
import activityUsTrade from './data/activity-us-trade-cn'
import activityTradeExpert from './data/activity-trade-expert-cn'
import activityStockTrans from './data/activity-stock-trans-cn'
import activityTradeStar from './data/activity-trade-star-cn'
import inviteFriend from './data/invite-friend-cn'

export default {
  // 通用翻译
  common: {
    confirm: '确定',
    return: '返回',
    cancel: '取消',
    noData: '暂无数据',
    reminder: '温馨提示',
    defaultInputHolder: '请输入',
    defaultSelectHolder: '请选择',
    copySuccess: '复制成功',
    copyNotSupport: '当前设备不支持复制',
    loadMore: '加载更多',
    noMore: '暂无更多',
    open: '打开',
    reqError: '请求失败，请稍后重试',
    stayTuned: '敬请期待',
    commonUse: '常用',
    goAppHandle: '请前往app进行操作',
    activityTime: '活动时间',
    appVersionNeedUpdate: '需更新app版本，以查看最新内容',
    hkCurrency: '港元',
    shareAppIntro: '盈宝证券-港股证券股市行情资讯社区平台\n实时行情海量资讯、牛人解读让您轻松把握投资机会',
    iKnowThat: '我知道了',
    openApp: '打开App'
  },

  router: {
    winbull: '盈宝证券',
    areaList: '国家/地区',
    download: '下载App'
  },

  login: {
    signIn: '登录',
    signUp: '注册',
    enterPhone: '请输入手机号',
    pleaseEnterCorrectPhone: '请输入正确的手机号',
    enterVcode: '输入验证码',
    pleaseEnterVcode: '请输入验证码',
    sendVcode: '发送验证码',
    reSendVcode: '重新发送验证码',
    countdown: '倒计时',
    pleasePickUserStatement: '请勾选用户协议',
    firstSignWillRegister: '首次登录将自动注册账号',
    iAgreed: '我已同意',
    serviceAgreement: '服务协议',
    registrationAgreement: '注册协议',
    and: '及',
    privacyAgreement: '隐私协议',

    userAccountLocked: '账号已锁定',
    pleaseCall: '请致电',
    serviceHotline: '服务热线',
    hongkongHotline: '香港',
    otherHotline: '其他',
    signInSuccess: '登录成功',
    registerChannelValid: '原有渠道已失效，点击跳转至官方渠道',

    captchaTitle: '请完成安全验证后继续：',
    captchaTips: '按住左边按钮拖动完成上方拼图',
    captchaVerifySuccess: '验证成功',
    captchaVerifyFail: '验证失败，请重试',
    captchaOutTime: '验证码已过期，请重试'
  },

  loginActivity: {
    newUserTxt1: '邀请您加入盈宝',
    newUserTxt2: '新人礼包直送<span>HK$2000+</span>',
    newUserIntro1: '注册就送<span>HK$88</span>礼包',
    newUserIntro2: '<span>0门槛开户</span>立享双重礼',
    newUserIntro3: '首笔入金到账HK$ 10000（或等值美元）及以上送<span>HK$800+</span>福利券',
    newUserIntro4: '额外再送邀请礼-<span>美股股票卡</span>',
    winbullIntroTitle: '为什么选择盈宝证券',
    winbullIntro1: '1分钟极速开户，便捷入金',
    winbullIntro2: '资金不闲置，货币基金T+0申赎，日日享收益',
    winbullIntro3: '自营投资组合，低回撤高收益，全球资产配置',
    winbullIntro4: '免费会员永不降级，港美股0佣金，融资利率低至5.6%',
    winbullIntro5: '一站式投资全球，一键开通港股、美股、基金账户',
    winbullIntro6: '安全保障，持有香港证监会颁发的第1/4/9类牌照',
    receiveReward: '领取奖励',
    registerReceive: '即刻注册领取'
  },

  download: {
    introText1: '免费加入会员享零佣金交易港美股',
    introText2: '持牌经纪人一对一服务',
    weixinDownloadTips: '请点击右上角按钮，选择在浏览器中打开',
    openDownloadTips1: '请点击右上角',
    openDownloadTips2: '选择浏览器打开',
    signUpSuccess: '注册成功！',
    pageDescTips: '只差一步就能体验全球投资乐趣<br />点击下载APP按钮，登录完成开户',
    downloadAppTips: '下载盈宝证券APP',
    downloadAppDesc: '新人福利大礼包现金赠股送不停，最高50倍日内融资'
  },

  activity: {
    goInApp: '进入盈宝证券APP',
    checkActivityDetail: '查看活动详情',
    knowIt: '已了解',
    pleaseUpdateApp: '请更新APP最新版本后体验',

    activityExplain: '本活动最终解释权归盈宝证券所有',
    activityEndDone: '活动已结束，感谢关注',
    releaseCountZero: '感谢关注活动，优惠券已发完',
    activityRule: '活动规则',
    activityRule2: '规则说明',
    awardCondition: '首入金 ≥ 10万HKD',
    activityTime: '活动时间：即日起 - 2022/12/31 23:59:59',
    receiveAward: '领取奖励',
    activityDissatisfied: '不满足参与活动条件',

    signUpGiftTitle: '注册有礼',

    openAccountGiftTitle: '开户有礼',
    hkLv2: '港股Lv2',
    day: '天',
    hkLv2Quote: '港股LV2高级行情',

    cashInGiftTitle: '入金有礼',
    cashInDesc1: '首入金 ≥ 10万HKD',
    cashInDesc2: '2万HKD ≤ 入金 < 10万HKD',
    receive: '领',

    winbullIntroduceTitle: '为什么选择盈宝',
    winbullIntroduceTitle2: '为什么选择盈宝证券',
    wbIntroTitle1: '持牌券商',
    wbIntroDesc1: '获认可的互联网券商，拥有1、4、9牌照',
    wbIntroTitle2: '产品理念',
    wbIntroDesc2: '以资产增值为目标，实现财富稳步增长',
    wbIntroTitle3: '知识社区',
    wbIntroDesc3: '专业知识分享社区，增值个人投资知识',
    wbIntroTitle4: '专业投顾',
    wbIntroDesc4: '连接专业投顾团队，强化资产管理模式',

    activityTips:
      '本活动优惠及广告不构成任何证券、金融产品或工具邀约、招揽、建议、意见或任何保证。投资有风险，入市需谨慎。',

    immediatelyOpen: '立即开户'
  },

  activityTradego: {
    activityTime: '活动时间：即日起至2022年11月30日 23:59:59',
    jd50GiftCard: '50元京东卡',
    hkNo6MonthCommission: '6个月港股免佣',
    cashInGiftTips: '提示：需 30 天内不出金及交易 1 次'
  },

  activityMultiple: {
    activityTime: '活动时间：即日起至2022年12月31日 23:59:59',
    aliTarget: '阿里系全体员工',
    xiaomiTarget: '小米系全体员工',
    tencentTarget: '腾讯系全体员工'
  },

  doc: {
    eventTerms: eventTerms,
    eventTermsTradego: eventTermsTradego,
    eventTermsMultiple: eventTermsMultiple
  },

  openAccount: {
    readyTitle: '盈宝证券在线极速开户',
    readyDesc: '1个账户投资港、美市场',
    readyEntryCnTitle: '内地用户开户',
    readyEntryCnDesc1: '7*24h',
    readyEntryCnDesc2: '领新人福利大礼包',
    readyEntryHkTitle: '香港用户开户',
    readyEntryHkDesc1: '知识社区',
    readyEntryHkDesc2: '汇聚全球星级投资达人',

    reviewingTitle: '开户资料审核中',
    reviewingDesc1: '预计1-3个工作日完成审核，',
    reviewingDesc2: '通过审核后更新内容即可生效，请耐心等待',

    failTitle: '未通过开户审核，请重新提交资料',
    failReason: '原因',
    goToSubmit: '去提交',

    setPwdDialogTitle: '设置登录密码后才可进行开户',
    nextTime: '下次再说',
    goSetting: '前往设置'
  },

  setPwd: {
    setUserPwd: '设置登录密码',
    phoneNumber: '手机号码',
    vcode: '验证码',
    pleaseEnterVcode: '请输入验证码',
    newPwd: '新密码',
    pleaseEnterNewPwd: '请输入新密码',
    rePwd: '确认新密码',
    pleaseEnterNewPwdAgain: '请再次输入新密码',
    pwdRuleTips: '密码为6-12位字符、数字组合',
    pwdFormatErr: '密码格式不正确',
    doublePwdErr: '两次密码输入不符',
    setSuccess: '设置成功'
  },

  wxBindRes: {
    bindSuccess: '绑定成功',
    bindSuccessTips: '绑定成功，将会收到最新的消息提醒',
    bindFail: '绑定失败',
    bindFailTips: '绑定失败，请联系盈宝客服或稍后再试',
    bindHasPass: '账号已绑定',
    bindHasPassTips: '请勿重复绑定账号'
  },

  activitySeedUser: {
    pageTitle: '新客豪礼活动',
    giftOneTitle: '开户大礼包',
    giftTwoTitle: '首入金奖励',
    giftThreeTitle: '更多奖励',
    noCommission: '免佣&平台费',
    noCommissionHk: '90天港股免佣金及平台费',
    noCommissionUs: '90天美股免佣金及平台费',

    giftTwoLeft1: '首入金 ≥ 2万HKD或等值美金',
    giftTwoLeft2: '首入金 ≥ 10万HKD或等值美金',
    giftTwoRight1: '奖励400HKD',
    giftTwoRight2: '奖励1500HKD',
    giftTwoTips: '提示：首入金奖励需30天不出金，并且30天至少交易一次',

    moreCardTxtTop1: '30天',
    moreCardTxtBottom1: '港股Lv2',
    moreTitle1: '新注册用户即赠',
    moreDesc1: '30天港股Lv2串流行情报价',
    moreDescTips1: '',
    moreCardTxtTop2: '2000元',
    moreCardTxtBottom2: '京东卡',
    moreTitle2: '收益率排行最高',
    moreDesc2: '可得2000元京东卡',
    moreDescTips2: '(具体看活动规则)',
    moreCardTxtTop3: '300HKD',
    moreCardTxtBottom3: '反馈奖励',
    moreTitle3: '产品优化反馈奖励',
    moreDesc3: '一经采用，奖励300～500HKD',
    moreDescTips3: '',

    shareTitle: '新客入金最高可领1500现金',
    shareContent: '开户入金免手续费，还有更多好礼赠送',
    immediatelyOpen: '立即开户',
    immediatelyCash: '立即入金',
    activityDissatisfied: '不满足参与条件'
  },

  activityNewUser: {
    pageTitle: '新客豪礼活动',
    cardOneTitle: '开户大礼包',
    cardTwoTitle: '如何拿到奖励',
    cardThreeTitle: '选择盈宝',

    cardOneDesc1: '首入金HKD 20000及以上，<br />30天未出金且交易一次',
    cardOneDesc2: '180天港股Lv2极速串流报价',
    cardOneFixed1: '现金券',
    cardOneFixed2: '行情券',

    cardTwoDesc1: '输入手机号<br />并登录APP',
    cardTwoDesc2: '点击交易<br />完成开户',
    cardTwoDesc3: '入金满2W<br />发放卡券',

    cardThreeItemTitle1: '以帮助客户盈利为目标',
    cardThreeItemDesc1: '智能盯盘，智盈策略，投资决策更高效',
    cardThreeItemTitle2: '超级会员权益',
    cardThreeItemDesc2: '港股佣金+美股佣金+暗盘佣金低至0元',
    cardThreeItemTitle3: '新型经纪人',
    cardThreeItemDesc3: '持牌经纪人，一对一专业服务',
    cardThreeItemTitle4: '互动社区',
    cardThreeItemDesc4: '社区有温度内容有深度，大咖互动接触财富快人一步',
    cardThreeItemTitle5: '一站式交易',
    cardThreeItemDesc5: '支持港股、美股、基金等投资标的，享受多元投资体验',
    receiveAward: '领取奖励',

    shareTitle: '盈宝HK$500现金券大派送',
    shareContent: '开户入金最高可得HKD$500',
    immediatelyOpen: '立即开户',
    immediatelyCash: '立即入金',
    activityDissatisfied: '不满足参与条件'
  },

  // 地区
  location: {
    motherCountry: '中国',
    hongKong: '香港',
    maCao: '澳门',
    taiWan: '台湾'
  },

  inviteFriend: inviteFriend,

  activityNewUser8: activityNewUser8,

  activityEssenceReward: activityEssenceReward,

  activityInviteFriend: activityInviteFriend,

  activityUsTrade: activityUsTrade,

  activityTradeExpert: activityTradeExpert,

  activityStockTrans: activityStockTrans,

  activityTradeStar: activityTradeStar
}
